/*
Fasteners

  --type <string::enum> | ['Bed Rail', 'Biscuit', 'Keyhole', 'Clips', 'Tite Joint']
  --pair <boolean::switch> | ['Pair', 'Individual']
*/
import { type } from '@/modules/standardItems/schemas/baseHeaders'
import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  type(),
  {
    text: 'Pair',
    value: 'pair',
    sortable: true,
    sort: 'boolean',
    render: 'boolean'
  }
]
